<template>
  <div class="group-page">
    <Header :title="title" :goBackHandler="goBack"></Header>
    <fixed-tab>
      <van-tabs slot="content" @change="onTabChange">
        <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name"></van-tab>
      </van-tabs>
    </fixed-tab>
    <Empty :empty_type="{name: '暂无拼团'}" v-if="list.length == 0" style="margin-top:20vw;"></Empty>
    <div class="content">
      <List
        ref="list"
        url="/api/app/spell/group"
        method="get"
        :params="{type: this.type}"
        :on-formatter="onFormatter"
        :on-getdata="onGetdata"
        :showText="list.length > 0"
      >
        <template slot="item">
          <course :list="list" v-if="type == 'course'"></course>
          <book :list="list" v-else></book>
        </template>
      </List>
    </div>
    <div class="foot-btn">
      <div>
        <p class="p2">拼团商城</p>
        <p class="p1" @click="$router.push({name:'MyGroup'})">我的拼团</p>
      </div>
    </div>
  </div>
</template>

<script>
import Empty from "@/components/Empty";
import Header from "@/components/Header";
import List from "@/components/List";
import book from "@/components/group/BookSpell";
import course from "@/components/group/CourseSpell";
export default {
  name: "Group",
  components: { Empty,Header, List, book, course },
  data() {
    return {
      tabs: [{ name: "课程", type: "course" }, { name: "图书", type: "book" }],
      list: [],
      type: "course",
      title: {
        name: "拼团商城"
      },
    };
  },
  methods: {
    goBack () {
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    onFormatter(row) {
      row.forEach(item => {
        if (item.group_user_avatars) {
          item.group_user_avatars = item.group_user_avatars.split(",");
        }else{
          item.group_user_avatars = [];
        }
      });
    },
    onGetdata(data) {
      if (this.type == "course") {
        data.forEach(item => {
          if (item.teachers.length > 3) {
            item.teachers = item.teachers.slice(0, 3);
          }
        });
      }
      this.list = data;
    },
    onTabChange(index) {
      this.type = this.tabs[index].type;
      this.$refs.list.reset();
    }
  }
};
</script>

<style lang="scss" scoped>
.group-page {
  /deep/{
  .van-tabs__line {
    width: 30px !important;
    height: 4px;
  }
  .van-tabs--line .van-tabs__wrap {
    border-bottom: none;
}
  .fixed-tab > div{
    top: 84px;
  }
  } 
  .content {
    padding: 30px;
  }
  .foot-btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100px;
    background: #fff;
    box-shadow: 0px -10px 16px 0px rgba(0, 0, 0, 0.02);
    z-index: 999;
    > div {
      width: 688px;
      height: 74px;
      margin: 13px auto;
      display: flex;
      border-radius: 37px;
      overflow: hidden;
      p {
        width: 50%;
        height: 74px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(65, 105, 255, 1);
        text-align: center;
        line-height: 74px;
      }
      .p1 {
        background: rgba(65, 105, 255, 0.1);
        color: $theme_color;
      }
      .p2 {
        background: $theme_color;
        color: #fff;
      }
    }
  }
}
</style>
